__turbopack_context__.v({
  "termsOfService": "o0AnwG_termsOfService",
  "termsOfServiceBody": "o0AnwG_termsOfServiceBody",
  "termsOfServiceContainer": "o0AnwG_termsOfServiceContainer",
});
